"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authAdyenContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const c = (0, core_1.initContract)();
exports.authAdyenContract = c.router({
    makeAdyenPaymentRequest: {
        method: 'POST',
        path: '/make-payment-request',
        body: zod_1.z.object({
            adyenPaymentSessionId: zod_1.z.string(),
            sessionId: zod_1.z.string(),
            adyenState: zod_1.z.any(),
            queryParams: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                resultCode: zod_1.z.string(),
                refusalReason: zod_1.z.optional(zod_1.z.string()),
                action: zod_1.z.any(),
            }),
        },
        summary: 'Make payment via adyen',
    },
    getAdyenPaymentDetails: {
        method: 'POST',
        path: '/get-payment-details',
        body: zod_1.z.object({
            adyenState: zod_1.z.any(),
        }),
        responses: {
            200: zod_1.z.object({
                resultCode: zod_1.z.optional(zod_1.z.string()),
                refusalReason: zod_1.z.optional(zod_1.z.string()),
            }),
        },
        summary: 'Get payment details',
    },
    getAdyenPaymentStatus: {
        method: 'GET',
        path: '/get-payment-status',
        query: zod_1.z.object({
            adyenPaymentSessionId: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                status: zod_1.z.string().nullable(),
            }),
            404: c.type(),
        },
    },
    getAdyenPaymentRefusalReason: {
        method: 'GET',
        path: '/get-payment-refusal-reason',
        query: zod_1.z.object({
            adyenPaymentSessionId: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                reason: zod_1.z.optional(zod_1.z.string()),
            }),
        },
        summary: 'Get payment refusal reason',
    },
    createApplePayMerchantSession: {
        method: 'POST',
        path: '/applepay-merchant-session/create',
        body: zod_1.z.object({
            validationUrl: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.any(),
        },
        summary: 'Get Apple pay merchant session',
    },
}, {
    pathPrefix: '/auth',
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=adyen.auth.contract.js.map